module.exports = __webpack_public_path__ + "media/images/persona-login-2caf9077503afc4be47268247dad8339797694c96cfef22494e25b6940eba5ad.png";